export const useLoader = (elemId: string) => {
	const startLoading = (): LoaderInstance => {
		const loaderInstance = window.newRtLoader(`#${elemId}`);
		loaderInstance.startLoader();
		return loaderInstance;
	};

	const stopLoading = (loader: LoaderInstance): void => {
		if (!loader) return;
		loader.stopLoader();
		loader.destroy();
	};

	return { startLoading, stopLoading };
};
